module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main', {
    staticClass: "main"
  }, [_c('header', {
    staticClass: "main__header"
  }, [_c('Icon', {
    attrs: {
      "size": "big",
      "type": _vm.status
    }
  }), _c('h3', {
    staticClass: "main__title"
  }, [_vm._v(_vm._s(_vm.title))])], 1), _c('Accordion', {
    attrs: {
      "opened": _vm.isOpened
    }
  }, [_c('div', {
    staticClass: "main__mentors"
  }, [_c('MentoringMember', {
    attrs: {
      "type": "куратор программы",
      "name": _vm.curatorName,
      "lastname": _vm.curatorLastname,
      "photo": _vm.curator.image,
      "gender": _vm.curator.gender,
      "asCurator": true
    }
  }), _c('MentoringMember', {
    attrs: {
      "type": "наставник программы",
      "name": _vm.mentorName,
      "lastname": _vm.mentorLastname,
      "photo": _vm.mentor.image,
      "gender": _vm.mentor.gender,
      "asCurator": true
    }
  })], 1), _c('Small', {
    staticClass: "main__start"
  }, [_vm._v(_vm._s(_vm.startDate))]), (_vm.list.length) ? _c('MentoringList', {
    attrs: {
      "list": _vm.list
    }
  }) : _vm._e()], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-44fcadf8","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/profile/modules/mentoring/programcard/components/main/MentoringMain.vue
// module id = cf3dad44a63132736c18
// module chunks = 89